import { Conversation } from 'graphModels/conversation';

export const Appointment = `
appointmentId
externalId
status
completedTimestamp
filePrerequisiteStatus
consultationType
subjects {
  description
  user {
    userId
    type
    profile {
      phoneNumber
      firstName
      lastName
      middleName
      dateOfBirth
      avatar
      policyId
      title
      email
      gender
      externalId
      address
      description
    }
  }
}
participants {
  userAvailability {
    status
  }
  participantType
  user {
    userId
    type
    profile {
      phoneNumber
      firstName
      middleName
      dateOfBirth
      lastName
      title
      gender
      avatar
      timezone
      email
      policyId
      externalId
      address
      description
    }
  }
}
providerGroupSpecialty {
  id
  name
}
allowedConversationTypes
conversations {
  ${ Conversation }
}
attachments {
  metaDataId
  mimeType
  encoding
  name
  thumbnail
  downloadRoute
  size
  comment
  status
}
schedules {
  startTime
  endTime
  status
}
summaries {
  summaryId
  authorId
  description
  referral
}
prescriptions {
  id
  drug {
    id
    title
  }
  dose
  medicationFrequency
  frequency
  frequencyUnit
  duration
  durationUnit
  comment
  status
}
service {
  serviceId
  name
  description
  logo
  conversationTypes
  providingUnit {
    orgNodeId
    name
    parentId
    logo
  }
  config {
    providerAvailabilityEnabled
    customerAvailabilityEnabled
    providerSelectionType
    subjectsEnabled
    subjectsRequired
    multiParticipantCallEnabled
    subjectsRequireIdentifiedUsers
    videoRecordingEnabled
    audioRecordingEnabled
    fileUploadsEnabled
    summaryEnabled
    prescriptionsEnabled
    selfServiceEnabled
    overlappingSchedules
    queueEnforcementType
    queueType
    schedulingType
    fixedAppointmentDuration
    defaultAppointmentDuration
    maxAppointmentDuration
    conversationTypeSelectionEnabled
  }
  filesPrerequisitesConfig {
    enabled
    attributes {
      minimumUploadedFiles
    }
  }
  predictiveDialerConfig {
    enabled
    triggerMethod
    fetchMethod
    providerState
    maxUnansweredVideoCalls
    unansweredVideoCallTimeOut
    maxUnansweredPhoneCalls
    unansweredPhoneCallTimeOut
    waitingRoomMaxWaitTarget
    switchVideoToPhone
  }
}
contract {
  contractId
}
permissions {
  orgNodeId
  roleResources {
    resourceCode
    create
    read
    update
    delete
    assign
  }
}
group {
  groupId
  currentAppointmentId
  appointments {
    appointmentId
    subject {
      subjectId
      userId
      description
      externalUserId
      user {
        userId
        type
        profile {
          firstName
          middleName
          lastName
          title
          gender
          avatar
          policyId
        }
      }
    }
    status
    version
    groupPosition
  }
}
attributes {
  fetchedBy
}
case {
  casePrerequisite {
    status
    errorMessage
  }
}
faceToFaceType
homeVisit {
  location {
    type
    address
  }
  vehicle {
    id
    name
    description
    externalId
  }
}
`;
